import { IStyles, styleGuide } from "theme";
import { ReactComponent as RNLogo } from "assets/images/logos/racenet/icon_racenetlogofull.svg";
import Typography from "@material-ui/core/Typography";
import { useEffect } from "react";
import { loadTrustArcScript } from "utils/loadTrustArcScript";
import { ITheme, useMediaQuery, useTheme } from "@material-ui/core";
import useFooterLinks from "hooks/useFooterLinks";

interface IProps {
    isMobile: boolean;
}

const Footer = ({ isMobile }: IProps) => {
    const theme: ITheme = useTheme();
    const sm = useMediaQuery(theme.breakpoints.down("sm"));
    const { links } = useFooterLinks();

    useEffect(() => {
        loadTrustArcScript();
    }, []);

    const styles: IStyles = {
        text: {
            ...styleGuide.typography.caption,
            fontSize: isMobile || sm ? 12 : 14,
            ...styleGuide.fontTypes.bold,
            color: styleGuide.color.coral,
            textTransform: "uppercase",
            textAlign: "center",
        },
        linkContainer: {
            display: "flex",
            justifyContent: "center",
        },
    };

    return (
        <div
            style={{
                display: "flex",
                flexDirection: isMobile ? "column-reverse" : "row",
                padding: isMobile
                    ? `${styleGuide.spacing(3)}px ${styleGuide.spacing(2)}px ${styleGuide.spacing(
                          4
                      )}px ${styleGuide.spacing(2)}px`
                    : styleGuide.spacing(3),
                backgroundColor: styleGuide.color.richGrey,
                justifyContent: "space-between",
                gap: styleGuide.spacing(isMobile ? 6 : 2),
            }}
        >
            <RNLogo style={{ height: 50 }} />
            <div
                style={{
                    display: "flex",
                    gridTemplateColumns: "repeat(4, auto)",
                    gap: "24px",
                    placeItems: "center",
                    justifyContent: "center",
                    paddingRight: "5px",
                    flexWrap: "wrap",
                }}
            >
                {links.map((link) => (
                    <div key={link.label} style={styles.linkContainer}>
                        <a href={link.url} target="_blank" rel="noreferrer">
                            <Typography style={styles.text}>{link.label.toUpperCase()}</Typography>
                        </a>
                    </div>
                ))}
                <div style={styles.linkContainer}>
                    <Typography style={styles.text}>
                        <div id="teconsent"></div>
                    </Typography>
                </div>
            </div>
        </div>
    );
};

export default Footer;
